import { unjspfTheme } from "../containers/themes/unjspfTheme";
import { idbTheme } from "../containers/themes/idbTheme";

export const appTheme = {
  UNJSPF: unjspfTheme,
  IDB: idbTheme,
};
